import React from 'react';

class About extends React.Component {
    render() {
        return (
            <div align="left" className='about'>
                <div className="row">
                    <h3>About</h3>
                </div>
                <div className="row">
                    <p>BoxScoreQ is a website to keep you updated on NBA games and their box scores quickly. Whenever I come home from work or school,
                    I open up and see what NBA games I should tune in to. However, I would always want to look at the box score first to see if there
                    is a particular game that might interest me like a game where Derrick Rose currently has 41 points or a game where Klay Thompson
                    is 6-7 from 3 point range. There wasn’t a quick place to find all the box scores in one place, which is why I made BoxScoreQ.</p>
                    <p>Find out more about this project at <a href="https://vandyliu.github.io/blog/2019/09/full-stack-nba-project">my blog</a></p>
                </div>
                <div className="row">
                    <h3>FAQ</h3>
                </div>
                <div className="row">
                    <ul>
                        <li>
                            <b>How far back can we check? </b>
                            You can check as far back as the 2014-15 season because this is how far back the stats nba API goes.
                            However before the 2018-19 season, player names were not included in the data, so player names may
                            not show up if you go too far back.
                    </li>
                        <li>
                            <b>How often are the box scores for the current day updated? </b>
                            Refresh and it will be up to date. Give or take a few seconds.
                    </li>
                    </ul>
                </div>
                <div className="row">
                    <h3> Todo </h3>
                </div>
                <div className="row">
                    <ul>
                        <li> Add more tests </li>
                        <li> Sort games by start time, in progress (closest to beginning of game), in progress (closest to end of game), other
                            stuff I have yet to think of</li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default About;